module.exports = __webpack_public_path__ + "img/kv.00132ffe.png";